import { Injectable } from '@angular/core';
import { VoiceFlow } from '../../../../../../models/order/workflow/voice/voice-flow.model';
import { BaseWorkflowStateService } from '../base-workflow-state.service';
import { ProductStatusType, StepStatusType } from '../../../../../../models/order/order.model';
import { AdditionalOfferData } from '../../../../../../models/order/workflow/additional-offer.model';


@Injectable({ providedIn: 'root' })
export class VoiceFlowStateService extends BaseWorkflowStateService<VoiceFlow> {
    override stateKey: string = 'voiceFlow';

    // Voice offers come from two owners — included offers (from the offers page) and directory/porting selections (from voice configuration)
    mergeVoiceOffers(newOffers: AdditionalOfferData[]): AdditionalOfferData[] {
        const ownedCodes = new Set(newOffers.map(o => o.customizationCode));
        const retained = (this.state()?.voiceOffers?.offers ?? [])
            .filter(o => !ownedCodes.has(o.customizationCode));
        return [...retained, ...newOffers];
    }

    updateStatus(value: ProductStatusType) {
        this.updateData({ status: this.mapProductStatusToFlowStatus(value) });
    }

    override async markStepComplete() {
        this.updateData({ status: StepStatusType.Completed });
    }

    private mapProductStatusToFlowStatus(status: ProductStatusType): StepStatusType {
        switch (status) {
            case ProductStatusType.COMPLETED:
                return StepStatusType.Completed;
            case ProductStatusType.STARTED_BUT_NOT_FINISHED:
                return StepStatusType.InProgress;
            case ProductStatusType.REQUIRES_ATTENTION:
                return StepStatusType.RequiresAttention;
            case ProductStatusType.NOT_AVAILABLE:
                return StepStatusType.NotAvailable;
            case ProductStatusType.AVAILABLE_NOT_STARTED:
                return StepStatusType.AvailableNotStarted;
            default:
                return StepStatusType.InProgress;
        }
    }
}
